<template>


    <!-- get in touch sec Start -->
    <section class="ec-get-in-touch section section-space-p">
        <div class="container">
            <div class="contact-map">
                <div class="row">

                    <div class="col-lg-6 col-md-12">
                        <div class="ec-contact-map">
                            <div class="ec-content-left">
                                <div class="ec_contact_map">
                                    <iframe :src="main?.settings?.map_url"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12 ec-content-right">
                        <div class="ec-content-right">

                            <div class="ec-contact-form">
                                <form @submit.prevent="create">
                                    <div class="table-heading">
                                        <h3>{{ $t('Contact us') }}</h3>
                                    </div>

                                    <div class="alert alert-danger" v-if="error_message !== null">
                                        {{ error_message }}
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-lg-12">
                                            <div class="form-group">

                                                <input type="text"
                                                       :class="{ 'is-invalid' : isInvalid('name')}"
                                                       v-model="item.name"
                                                       :placeholder="$t('Name')"
                                                       required/>

                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('name')">
                                                    {{ isInvalid('name') }}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col-md-6 col-sm-6 col-lg-6">
                                            <div class="form-group">
                                                <input type="text" dir="ltr"
                                                       :class="{ 'is-invalid' : isInvalid('phone')}"
                                                       :placeholder="$t('Phone')"
                                                       v-model="item.phone"
                                                       required/>
                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('phone')">
                                                    {{ isInvalid('phone') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-6">
                                            <div class="form-group">
                                                <input type="email" dir="ltr" id="email" class="form-control"
                                                       v-model="item.email"
                                                       :placeholder="$t('Email')"
                                                       :class="{ 'is-invalid' : isInvalid('email')}">

                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('email')">
                                                    {{ isInvalid('email') }}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">

                                        <div class="col-md-6 col-sm-6 col-lg-6">
                                            <div class="form-group">

                                                <select class="form-control border form-select " id="purpose"
                                                        v-model="item.purpose"
                                                        :placeholder="$t('Purpose of connection') "
                                                        :class="{ 'is-invalid' : isInvalid('purpose')}">
                                                    <option value="" selected="" disabled="" hidden=""
                                                            style="display: none;"></option>
                                                    <option v-for="(value,key) in form_options?.purpose" :value="key">{{
                                                            value
                                                        }}
                                                    </option>
                                                </select>
                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('purpose')">
                                                    {{ isInvalid('purpose') }}
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-6">
                                            <div class="form-group">

                                                <select class="form-control border form-select " id="importance"
                                                        v-model="item.importance"
                                                        :placeholder="$t('Importance of communication')"
                                                        :class="{ 'is-invalid' : isInvalid(importance)}">
                                                    <option value="" selected="" disabled="" hidden=""
                                                            style="display: none;"></option>
                                                    <option v-for="(value,key) in form_options?.importance"
                                                            :value="key">
                                                        {{ value }}
                                                    </option>
                                                </select>
                                                <div class=" invalid-feedback text-danger"
                                                     v-if="isInvalid('importance')">
                                                    {{ isInvalid('importance') }}
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-lg-12">
                                            <div class="form-group">

                                            <textarea v-model="item.message"
                                                      id="message"
                                                      class="form-control"
                                                      :placeholder="$t('Message')"
                                                      :class="{ 'is-invalid' : isInvalid('message')}"></textarea>

                                                <div class=" invalid-feedback text-danger" v-if="isInvalid('message')">
                                                    {{ isInvalid('message') }}
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4 col-sm-4 col-lg-4">
                                            <button type="submit" class="submit-btn">
                                                {{ $t('Send Message') }} <span class="cart-icon"> </span>
                                            </button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();

import alertErrors from "../handling/alert-errors";

export default {
    props: ['main'],
    components: {
        alertErrors,
    },
    data() {
        return {
            contact_data: [],
            form_options: {},
            item: {},
            validationErrors: null,
            error_message: null,
        }
    },
    created() {


        const id = toast.info(this.$t('getting options ...'), {icon: 'fa-light fa-filter-list'});

        const that = this;

        axios.get('contact_us/create').then(response => {
            toast.dismiss(id);
            this.form_options = response.data.elements;
        }).catch(function (error) {
            toast.dismiss(id);
            if (error.response) {
                that.validationErrors = error.response.data.errors;
            }
        });

        this.getResults();


    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        getResults() {
            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});
            axios.get('contacts_data').then(response => {
                toast.dismiss(id);
                this.contact_data = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
        create() {

            const id = toast.info(this.$t('Adding content...'), {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;
            this.error_message = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('contact_us',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});

                this.item = {};
                // this.$router.push({name: 'home', params: {lang: this.$i18n.locale}});

            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    that.error_message = error.response.data.message;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });

        }
    }
}
</script>
